import Compress from 'compress.js'

export async function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

export function base64RemoveMetadata(string: string): string {
  return string.split(',')[1]
}

const compress = new Compress()

const maxImageSize = 800

export async function compressBase64(base64: string) {
  const compressedData = await fetch(base64)
    .then((res) => res.blob())
    .then((blob) =>
      compress.compress([blob], {
        size: 1, // the max size in MB, defaults to 2MB
        quality: base64.includes('jpeg') || base64.includes('jpg') ? 0.9 : 1, // the quality of the image, max is 1,
        maxWidth: maxImageSize, // the max width of the output image, defaults to 1920px
        maxHeight: maxImageSize, // the max height of the output image, defaults to 1920px
        resize: true, // defaults to true, set false if you do not want to resize the image width and height
        rotate: false // See the rotation section below
      })
    )
  return compressedData[0].data
}

export const handleSaveToPC = (contactsData: any, fileName?: string) => {
  const fileData = JSON.stringify(contactsData)
  const blob = new Blob([fileData], { type: 'text/plain' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.download = `${fileName ?? 'filename'}.json`
  link.href = url
  link.click()
}

export function getStringSizeInKB(str: string): number {
  const blob = new Blob([str], { type: 'text/plain' })
  return blob.size / 1024
}
